import React from 'react';
import { useAppSelector } from '../store';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
  const { isAuthorized } = useAppSelector(state => state.authorization);

  return (
    isAuthorized ? <Outlet /> : <Navigate to='/' />
  );
};

export default PrivateRoutes;
